

import { CarBusinessLine } from "../../car/constants/car-basic-data";
import { Country } from "../models/country.model";
import { AppConstants } from "./app-constants";

export type CarDocumentType = "REG_CERTIFICATE" | "DRIVER_LICENCE" | "INSURANCE_POLICY" | "INSURANCE_QUOTE";

export enum PaymentStatus {
  NEW = "NEW",
  PENDING = "PENDING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED"
}

export enum Currency {
  XAF = "XAF",
  XOF = "XOF",
  USD = "USD",
  CAD = "CAD",
  EUR = "EUR"
}

export enum ObjectSource {
  DEALER = "DEALER",
  BUY = "BUY",
  RENT = "RENT",
  KEEP = "KEEP",
  PARK = "PARK",
  DETAILS = "DETAILS",
  SEARCH = "SEARCH"
}

export class GeneralBasicData {

    static countryCodes = AppConstants.COUNTRY_CODE_OPTIONS;

    public static getObjectSource(businessLine: CarBusinessLine): ObjectSource{
      switch(businessLine){
        case CarBusinessLine.BUY : {
          return ObjectSource.BUY
          break;
        }
        case CarBusinessLine.RENT : {
          return ObjectSource.RENT
          break;
        }
        case CarBusinessLine.KEEP : {
          return ObjectSource.KEEP
          break;
        }
        default : {
          return ObjectSource.BUY
          break;
        }
      }
  }
  
    public static getDefaultCountry(): Country{
        let country: Country;
        let code = "BF";
        return new Country(code, this.countries_cities[code].name, this.countries_cities[code].phoneCode, this.countries_cities[code].currency );
    }

    public static getDefaultCurrency(): Currency {
      let country: Country = this.getDefaultCountry();
      let curr = this.getCountryCurrencyByCode(country.code);
      return  curr == null ? Currency.USD : curr;
  }

    public static getAllCountryNames(): string[]{
      let cntrs: string[] = [];
      this.countryCodes.forEach((code) => cntrs.push(this.countries_cities[code].name));
      
      return cntrs;
  }

    public static getAllCountryPhoneCodes(): number[]{
      let codes: number[] = [];
      this.countryCodes.forEach((code) => codes.push(this.countries_cities[code].phoneCode));
      
      return codes;
  }
  
    public static getAllCountries(): Country[]{
      let cntrs: Country[] = [];
      this.countryCodes.forEach((code) => cntrs.push(new Country(code, this.countries_cities[code].name, this.countries_cities[code].phoneCode, this.countries_cities[code].currency )));
      
      return cntrs;
  }
  
    public static getAllCities(countries: string[]): string[]{
        let cities: string[] = [];
        this.countryCodes.forEach((code) => {
          if(countries.includes(code)){
            cities = [ ...cities, ...this.countries_cities[code].cities];
          }
        });
        return cities;       
    }
  
    static getCountryByCode(code: string): Country | null {

      let country = this.countries_cities[code];

      return (country==undefined)? null : new Country(code, country.name, country.phoneCode, country.currency);
   
    }

    static getCountryNameByCode(code: string): string | null {

      let country = this.countries_cities[code];

      return (country==undefined)?'':country.name;
    }

    static getCountryCurrencyByCode(code: string): Currency | null {

      let country = this.countries_cities[code];

      return (country==undefined) ? null : country.currency;
    }

    static getCountriesByCodes(codes: string[]): Country[] | null {

      let countries: Country[] = [];

      codes.forEach( 
        (code) => {
          countries.push(new Country(code, this.countries_cities[code].name, this.countries_cities[code].phoneCode, this.countries_cities[code].currency));
        }
      );

      return countries;
    }

    public static carDocumentTypesOld: any = {
      REG_CERTIFICATE: {
        code: "REG_CERTIFICATE",
        desc: "Carte grise"
      },
      DRIVER_LICENCE: {
        code: "DRIVER_LICENCE",
        desc: "Permis de conduire"
      },
      INSURANCE_POLICY: {
        code: "INSURANCE_POLICY",
        desc: "Police d'assurance"
      },
      INSURANCE_QUOTE: {
        code: "INSURANCE_QUOTE",
        desc: "Devis police"
      }
    }
 

    public static carDocumentTypes: any = [
      {
        code: "REG_CERTIFICATE",
        desc: "Carte grise"
      },
      {
        code: "DRIVER_LICENCE",
        desc: "Permis de conduire"
      },
      {
        code: "INSURANCE_POLICY",
        desc: "Police d'assurance"
      },
      {
        code: "INSURANCE_QUOTE",
        desc: "Devis police d'assurance"
      }
    ];

 /*
    
    public static getAllCarDocumentTypeDesc(): string[]{
      let types: string[] = [];

      this.carDocumentTypes1.forEach((type: any) => types.push(this.carDocumentTypes1[type].name));
      
      return types;
    }

    public static getAllCarDocumentTypes(): any[]{
      let types: any[] = [];

      this.carDocumentTypes1.forEach((type: any) => types.push(this.carDocumentTypes1[type]));
      
      return types;
    }
*/ 
    private static countries_cities: any = {
      CM: {
        code: "CM",
        name: "Cameroun",
        phoneCode: 237,
        currency: Currency.XAF,
        cities: [
          "Douala",
          "Yaounde",
          "Limbe",
          "Garoua",
          "Maroua",
          "Bertoua",
          "Bafoussam",
          "Kribi",
          "Ebolowa",
          "Buea"
        ]
      },
      
      CI: {
        code: "CI",
        name: "Cote d'Ivoire",
        phoneCode: 225,
        currency: Currency.XOF,
        cities: [
          "Abidjan",
          "Yamoussoukro",
          "Gagnoa",
          "Boaké",
          "Daloa",
          "Korhogo",
          "Agboville",
          "Divo",
          "Man",
          "San-Pédro"
        ]
      },
      SN: {
        code: "SN",
        name: "Senegal",
        currency: Currency.XOF,
        phoneCode: 221,
        cities: [
          "Dakar",
          "Pikine",
          "Touba",
          "Thiès",
          "Kaolack",
          "Saint-Louis",
          "Kolda",
          "Dagana",
          "Sokone",
          "Mboro"
        ]
      },
      
      ML:  {
        code: "ML",
        name: "Mali",
        currency: Currency.XOF,
        phoneCode: 223,
        cities: [
          "Bamako",
          "Sikasso",
          "Mopti",
          "Koutiala",
          "Kayes",
          "Ségou",
          "Gao",
          "Tombouctou",
          "Kolokani",
          "Sokolo"
        ]
      },
      BJ:  {
        code: "BJ",
        name: "Benin",
        currency: Currency.XOF,
        phoneCode: 229,
        cities: [
          "Cotonou",
          "Porto-Novo",
          "Parakou",
          "Abomey",
          "Djougou",
          "Abomey-Calavi",
          "Kandi",
          "Allada",
          "Bohicon",
          "Savé"
        ]
      },
      GA: {
        code: "GA",
        name: "Gabon",
        currency: Currency.XAF,
        phoneCode: 241,
        cities: [
          "Libreville",
          "Port-Gentil",
          "Franceville",
          "Oyem",
          "Makokou",
          "Bitam",
          "Ntoum",
          "Moanda",
          "Tchibanga",
          "Koulamoutou",
          "Lastourville"
        ]
      },
      GW: {
        code: "GW",
        name: "Guinee Equatoriale",
        currency: Currency.XAF,
        phoneCode: 240,
        cities: [
          "Bata",
          "Malabo",
          "Ebebiyin",
          "Aconibe",
          "Luba",
          "Mongomo",
          "Rebola",
          "Niefang",
          "Evinayong",
          "Cogo"
        ]
      },
      TD: {
        code: "TD",
        name: "Tchad",
        currency: Currency.XAF,
        phoneCode: 235,
        cities: [
          "N'Djamena",
          "Moundou",
          "Abeche",
          "Sarh",
          "Koumra",
          "Mongo",
          "Pala",
          "Bongor",
          "Faya-Largeau",
          "Kélo"
        ]
      },
      CD:  {
        code: "CD",
        name: "Congo Kinshassa",
        currency: Currency.USD,
        phoneCode: 243,
        cities: [
          "kinshassa",
          "Mbujimayi",
          "Lumbumbashi",
          "Kananga",
          "Goma",
          "Bukavu",
          "Tshikapa",
          "Kisangani",
          "Kolwezi",
          "Likasi"
        ]
      },
      BF: {
        code: "BF",
        name: "Burkina Faso",
        currency: Currency.XOF,
        phoneCode: 226,
        cities: [
          "Ouagadougou",
          "Bobo-Dioulasso",
          "Kaya",
          "Ouahigouya",
          "Dori",
          "Banfora",
          "Tenkodogo",
          "Fada N'Gourma",
          "Solenzo",
          "Houndé"
        ]
      }
    };
  
    /*
    private static countries_cities_old = [
      {
        "id": 1,
        "country": "CM",
        "name": "Cameroun",
        "cities": [
          "Douala",
          "Yaounde",
          "Limbe",
          "Garoua",
          "Maroua",
          "Bertoua",
          "Bafoussam",
          "Kribi",
          "Ebolowa",
          "Buea"
        ]
      },
      
      {
        "id": 2,
        "country": "CI",
        "name": "Cote d'Ivoire",
        "cities": [
          "Abidjan",
          "Yamoussoukro",
          "Gagnoa",
          "Boaké",
          "Daloa",
          "Korhogo",
          "Agboville",
          "Divo",
          "Man",
          "San-Pédro"
        ]
      },
        {
        "id": 3,
        "country": "SN",
        "name": "Senegal",
        "cities": [
          "Dakar",
          "Pikine",
          "Touba",
          "Thiès",
          "Kaolack",
          "Saint-Louis",
          "Kolda",
          "Dagana",
          "Sokone",
          "Mboro"
        ]
      },
        {
        "id": 4,
        "country": "ML",
        "name": "MALI",
        "cities": [
          "Bamako",
          "Sikasso",
          "Mopti",
          "Koutiala",
          "Kayes",
          "Ségou",
          "Gao",
          "Tombouctou",
          "Kolokani",
          "Sokolo"
        ]
      },
        {
        "id": 5,
        "country": "BJ",
        "name": "Benin",
        "cities": [
          "Cotonou",
          "Porto-Novo",
          "Parakou",
          "Abomey",
          "Djougou",
          "Abomey-Calavi",
          "Kandi",
          "Allada",
          "Bohicon",
          "Savé"
        ]
      },
        {
        "id": 6,
        "country": "GA",
        "name": "GABON",
        "cities": [
          "Libreville",
          "Port-Gentil",
          "Franceville",
          "Oyem",
          "Makokou",
          "Bitam",
          "Ntoum",
          "Moanda",
          "Tchibanga",
          "Koulamoutou",
          "Lastourville"
        ]
      },
        {
        "id": 7,
        "country": "GW",
        "name": "GUINEE BISSAU",
        "cities": [
          "Bata",
          "Malabo",
          "Ebebiyin",
          "Aconibe",
          "Luba",
          "Mongomo",
          "Rebola",
          "Niefang",
          "Evinayong",
          "Cogo"
        ]
      },
        {
        "id": 8,
        "country": "TD",
        "name": "TCHAD",
        "cities": [
          "N'Djamena",
          "Moundou",
          "Abeche",
          "Sarh",
          "Koumra",
          "Mongo",
          "Pala",
          "Bongor",
          "Faya-Largeau",
          "Kélo"
        ]
      },
        {
        "id": 9,
        "country": "CD",
        "name": "Congo Kinshassa",
        "cities": [
          "kinshassa",
          "Mbujimayi",
          "Lumbumbashi",
          "Kananga",
          "Goma",
          "Bukavu",
          "Tshikapa",
          "Kisangani",
          "Kolwezi",
          "Likasi"
        ]
      },
        {
        "id": 10,
        "country": "BF",
        "name": "BURKINA FASO",
        "cities": [
          "Ouagadougou",
          "Bobo-Dioulasso",
          "Kaya",
          "Ouahigouya",
          "Dori",
          "Banfora",
          "Tenkodogo",
          "Fada N'Gourma",
          "Solenzo",
          "Houndé"
        ]
      }
    ];
  */
  
  }
  
  